// ***************************** yearly end date format ************************

export const getDateRange = (view, selectedDate) => {
  let startDate;
  let endDate;

  if (view === "daily") {
    startDate = selectedDate;
    endDate = selectedDate;
  } else if (view === "weekly") {
    startDate = selectedDate.startOf("week");
    endDate = selectedDate.endOf("week");
  } else if (view === "monthly") {
    startDate = selectedDate.startOf("month");
    endDate = selectedDate.endOf("month");
  } else if (view === "yearly") {
    startDate = selectedDate.startOf("year");
    endDate = selectedDate.endOf("year");
  }

  return { startDate, endDate };
};
